import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M20.1 16.1v-3.2c0-.5-.5-1-1-1-.6 0-1 .5-1 1v3h-2.5c-.7 0-1.3.5-1.5.7-.1 0-.1.1-.1.2l-.4.6H8.5l-.4-.5v-.1s0-.1-.1-.1c-.3-.3-.8-.7-1.5-.7H4V6.5c0-.3.3-.6.8-.6H11c.5 0 1-.4 1-1 0-.5-.5-1-1-1H4.8C3.4 3.9 2 4.8 2 6.5v9.6c-.1.1-.3.1-.4.2l-.1.1c-.3.4-.5.9-.5 1.5v1c0 1.7 1.4 3 3 3h14.1c1.7 0 3-1.3 3-3v-1c0-.6-.2-1.1-.6-1.4-.1-.2-.2-.3-.4-.4M3 17.8h3.6l.4.5v.1s0 .1.1.1c.2.2.8.7 1.5.7h5c.7 0 1.3-.3 1.6-.8l.3-.5.1-.1h3.5v1c0 .5-.5 1-1 1H4c-.5 0-1-.5-1-1z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "m23.1 10.5-2-2c.4-.7.7-1.5.7-2.3 0-1.1-.5-2.1-1.2-2.9-1.6-1.6-4.4-1.6-6.1 0-.8.7-1.2 1.7-1.2 2.8s.5 2.3 1.3 3.1 1.9 1.2 3 1.2c.7 0 1.5-.2 2.1-.6l2 2c.2.2.5.3.7.3.3 0 .5-.1.7-.3.3-.3.3-.9 0-1.3m-3.8-2.6c-1 .9-2.5.9-3.5 0-.5-.4-.8-1.1-.8-1.8 0-.6.2-1.2.7-1.6 1-1 2.6-1 3.6 0s.9 2.5 0 3.4m-8.2 1.7c.4 0 .8-.3.8-.8 0-.4-.3-.8-.8-.8H5.9c-.4 0-.8.3-.8.8 0 .4.3.7.8.8zm-6 3.3c0 .4.3.7.8.8h9.2c.4 0 .7-.4.7-.8s-.3-.7-.8-.7H5.9c-.4-.1-.8.2-.8.7" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }